<template>
  <div>
    <div class="bg_box">
      <div class="element_point" v-for="(element, index) in elementPoint" :key="index" :style="getStyle(element)">
        <div class="element_point_item">
          <p class="text">{{ element.name }}</p>
        </div>
        <div class="element_point_item">
          <el-select size="mini" v-model="newKeyData[index]" placeholder="请选择">
            <el-option
              v-for="(item, index) in getUnityData(cacheDataTypes, element, index)"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="mt16">
      <el-button type="primary" @click="getElementInLaout">生成相位图</el-button>
      <el-button type="primary" @click="updateElementInLayout">更新组件</el-button>
    </div>
  </div>
</template>

<script>
import {
  handleFindLayoutComponentOptionsCols,
  handleFindLayoutComponentOptions,
  getAllColsUidInLayoutComponent,
  isFieldAllEmpty
} from "utils"
import { fixComponent } from "@/utils/analysisTypeId.js"
import { CATEGORY_MODE } from "@/consts"
export default {
  name: "colsElementDescriptor",
  props: {
    changeAll: { type: Boolean, default: false },
    typeVal: { type: String, default: "123" },
    restDataUrl: { type: String, default: "1234" }
  },
  data() {
    return {
      newKeyData: [],
      cacheDataTypes: [],
      colsIdFromActiveRect: [],
      complateData: null,
      resIndex: null,
      elementPoint: [
        // {
        //     name: '轮播',
        //     left: 10,
        //     top: 10,
        //     width: 30,
        //     height: 30,
        // }
      ]
    }
  },
  methods: {
    getUnityData(data, ele, index) {
      const result = []
      //获取匹配位置的index
      if (!this.resIndex) {
        // if (this.resIndex === null || this.resIndex < 0) {
        if (data.length > 0 && ele) {
          let item = null,
            resIndex = null
          for (let i = 0; i < data.length; i++) {
            item = data[i]
            resIndex = item.findIndex(item2 => item2.label === ele.value)
            if (resIndex !== -1) break
          }
          this.resIndex = resIndex
        }
      }
      // -------------------------------------
      if (this.resIndex && this.resIndex >= 0) {
        data.forEach(item => {
          if (item[this.resIndex].value.component_shape === ele.shape) {
            result.push({
              label: item[this.resIndex].value.key,
              value: item[this.resIndex]
            })
          }
        })
      }
      return result
    },
    updateElementInLayout() {
      const execute = this.chckDataComplete(this.newKeyData, this.elementPoint)
      if (!this.changeAll) {
        this.upDateNowCol()
      } else {
        if (!execute) {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            message: "检测到有数据未选择，请检查数据！",
            type: "warning"
          })
        } else {
          this.upDateNowCol()
          this.updateAllElementInLayout()
        }
      }
    },
    chckDataComplete(newKeyData, elementPoint) {
      const data = newKeyData.slice(0, elementPoint.length)
      return data.every(item => item !== null)
    },
    // 更新所有的cols
    updateAllElementInLayout() {
      let nowIdIndex = this.colsIdFromActiveRect.findIndex(item => item == this.ids.uid)
      // _colsIdFromActiveRect.splice(nowIdIndex, 1)
      //分别设置当前uid前的updateId和当前ui后的upateID
      let firstUpdateIndex = nowIdIndex
      let secondUpdateIndex = nowIdIndex
      //当当前位置id（firstUpdateIndex） 减少到等于0说明在当前id之前的cols已经更新完毕
      while (firstUpdateIndex > 0) {
        firstUpdateIndex-- //当前updateindex--
        let _tempKeyData = this.getNewKeyData(firstUpdateIndex, this.complateData, this.newKeyData)
        let tempIds = JSON.parse(JSON.stringify(this.ids)) //当前的ids
        let tempUid = this.colsIdFromActiveRect[firstUpdateIndex] //当前uid的index对应的uid
        _tempKeyData.forEach((item, index) => {
          if (item) {
            let valueKeyName = this.getValueKeyName(item.value["component_shape"])
            let elementInLayoutId = this.elementPoint[index].elementInLayOutId
            tempIds.elementInLayoutId = elementInLayoutId
            tempIds.uid = tempUid
            this.changeOptionsEV(item.label, valueKeyName, false, null, tempIds)
          }
        })
      }
      //当当前位置id（secondUpdateIndex） 加到等于this.colsIdFromActiveRect的length说明在当前id之后的cols已经更新完毕
      while (secondUpdateIndex < this.colsIdFromActiveRect.length - 1) {
        secondUpdateIndex++ //当前updateindex--
        let _tempKeyData = this.getNewKeyData(secondUpdateIndex, this.complateData, this.newKeyData)
        let tempIds = JSON.parse(JSON.stringify(this.ids)) //当前的ids
        let tempUid = this.colsIdFromActiveRect[secondUpdateIndex] //当前uid的index对应的uid
        _tempKeyData.forEach((item, index) => {
          if (item) {
            let valueKeyName = this.getValueKeyName(item.value["component_shape"])
            let elementInLayoutId = this.elementPoint[index].elementInLayOutId
            tempIds.elementInLayoutId = elementInLayoutId
            tempIds.uid = tempUid
            this.changeOptionsEV(item.label, valueKeyName, false, null, tempIds)
          }
        })
      }
    },
    //把单步数据处理成this.newkeydata的样子
    getNewKeyData(firstUpdateIndex, complateData, newKeyData) {
      let result = []
      newKeyData.forEach(item => {
        if (item) {
          let tempSingleData = complateData[firstUpdateIndex]
          Object.keys(tempSingleData).forEach(key => {
            if (tempSingleData[key].key == item.value.key) {
              result.push({
                label: tempSingleData[key].value,
                value: { ...tempSingleData[key] }
              })
            }
          })
        }
      })
      return result
    },
    upDateNowCol() {
      let tempIds = JSON.parse(JSON.stringify(this.ids))
      this.newKeyData.forEach((item, index) => {
        if (item) {
          let valueKeyName = this.getValueKeyName(item.value["component_shape"])
          let elementInLayoutId = this.elementPoint[index].elementInLayOutId
          tempIds.elementInLayoutId = elementInLayoutId
          this.changeOptionsEV(item.label, valueKeyName, false, null, tempIds)
        }
      })
    },
    //生成相位图中的方块
    getElementInLaout() {
      //后台数据监测，如果未获取后台数据就点击生成相位图就会报错
      this.createSelect()
      this.elementPoint = []
      let result = handleFindLayoutComponentOptionsCols(this.pOptions, this.ids.uid)
      const originWidth = document.getElementById(`componentBox_after${result.uid}`).offsetWidth
      const originHeight = document.getElementById(`componentBox_after${result.uid}`).offsetHeight
      const widthProportion = (this.$el.offsetWidth * 0.95) / originWidth
      const heightProportion = 200 / originHeight
      let elementInLayout = result
      if (!!!elementInLayout.elementOptions) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "warning",
          message: "当前选中列中没有任何组件哦，请先生成组件"
        })
        return
      } else {
        elementInLayout = elementInLayout.elementOptions
      }
      elementInLayout.forEach(element => {
        this.elementPoint.push({
          value: element.content ? element.content : element.imgSrc,
          elementInLayOutId: element.elementInLayoutId,
          shape: element.innerElement,
          name: this.getElementName(element.innerElement),
          left: element.left * widthProportion,
          top: element.top * heightProportion,
          width: element.width * widthProportion,
          height: element.height * heightProportion
        })
      })
    },
    getStyle(elements) {
      const element = elements
      element.height = element.height < 36 ? 36 : element.height
      return {
        // lineHeight: element.height + "px",
        width: "100%",
        left: 0,
        top: 0,
        height: "100%",
        background: "gray",
        border: "1px solid gray",
        borderRadius: "4px",
        color: "black"
      }
    },
    async createSelect() {
      let result = await this.getAppointData()
      result = result.data.data.datas.datas
      this.complateData = this.getAllUidInlayoutComponent(result)
      const _cacheDataTypes = []
      if (!this.complateData.length) return
      for (let i = 0; i < Object.keys(this.complateData[0]).length; i++) {
        _cacheDataTypes.push([]), this.newKeyData.push(null)
      }
      this.complateData.forEach((item, index) => {
        Object.keys(item).forEach((key, keyindex) => {
          const tempValue = item[key].value
          // const tempLabel = item[key].component_shape
          _cacheDataTypes[keyindex][index] = {
            value: item[key],
            label: tempValue
          }
        })
      })
      this.cacheDataTypes = _cacheDataTypes
    },
    async getAppointData() {
      const { typeVal, restDataUrl } = this
      return this.instance.get(`engine2${restDataUrl.slice(8)}${typeVal}`)
    },
    //过滤掉数据中没用的数据和空数据，并给每个数组元素判断出需要增加的组件类型
    getDataInfo(result) {
      const _result = JSON.parse(JSON.stringify(result))
      Object.keys(_result).forEach(key => {
        Object.keys(_result[key]).forEach(dataItemKey => {
          if (!!Number(dataItemKey) !== true && Number(dataItemKey) !== 0) {
            delete _result[key][dataItemKey]
          } else {
            if (isFieldAllEmpty(_result, dataItemKey)) {
              delete _result[key][dataItemKey]
            } else {
              const componentShape = fixComponent(dataItemKey)
              _result[key][dataItemKey].component_shape = componentShape
            }
          }
        })
      })
      return _result
    },
    //递归查找布局组件中所有的可使用的col
    getAllUidInlayoutComponent(result) {
      const rectAttr = this.getRectAttribute.call(this, this.ids).options
      const useActiveIndex = rectAttr.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.activeIndex
      const pOptions = [rectAttr.rows[useActiveIndex]]
      this.colsIdFromActiveRect = getAllColsUidInLayoutComponent(pOptions)
      return this.drawData(result)
    },
    //查找布局组件中，cols里没有rows的列
    drawData(result) {
      let drawLayoutAlready = null
      const pOptions = this.getRectAttribute.call(this, this.ids).options.rows
      let elementInlayout = null
      //循环判断遍历出的最底层cols中是否为空（列中没有组件）
      for (let i = 0; i < this.colsIdFromActiveRect.length; i++) {
        let tempUid = this.colsIdFromActiveRect[i]
        elementInlayout = handleFindLayoutComponentOptions(pOptions, tempUid)
        if (typeof elementInlayout !== "undefined" && elementInlayout.length > 0) {
          drawLayoutAlready = {
            uid: tempUid,
            elementInlayout: elementInlayout
          }
          break
        }
      }
      //数据处理
      return this.getDataInfo(result)
    },
    randomColor() {
      let color = "rgb("
      for (var i = 0; i < 3; i++) color += parseInt(Math.random() * 256) + ","
      //去除最后一个逗号
      // color=color.slice(0,-1)
      color = color.substring(0, color.length - 1) + ")"
      return color
    },
    getValueKeyName(shape) {
      let result = null
      switch (shape) {
        case "imageComponent":
          result = "imgSrc"
          break
        case "cxText":
          result = "content"
          break
        case "swiperComponent":
          result = "content"
          break

        default:
          break
      }
      return result
    },
    getElementName(shape) {
      let name = null
      switch (shape) {
        case "swiperComponent":
          name = "轮播组件"
          break
        case "layoutComponent":
          name = "布局组件"
          break
        case "emptyLayoutComponent":
          name = "自由布局组件"
          break
        case "cxText":
          name = "文本组件"
          break
        case "imageComponent":
          name = "图片组件"
          break
        default:
          break
      }
      return name
    },
    changeOptionsEV(val, content_name, deep, optionName, ids) {
      if (val !== undefined && content_name !== undefined) {
        let result = null
        if (ids.uid !== null) {
          const pOptions = this.getRectAttribute.call(this, ids).options.rows
          const uid = this.$store.state.states.activeID.uid
          result = handleFindLayoutComponentOptions(pOptions, uid).find(
            it => it.elementInLayoutId === ids.elementInLayoutId
          )
          // result = JSON.parse(window.localStorage.getItem(uid))
        } else {
          result = JSON.parse(JSON.stringify(this.getRectAttribute.call(this, ids)))
        }
        let param = null
        if (!!!deep) {
          param = {
            option_name: content_name,
            option_val: val
          }
        } else {
          result[optionName][content_name] = val
          param = {
            option_name: optionName,
            option_val: result[optionName]
          }
        }
        let completeparam = Object.assign(param, ids)
        if (ids.uid) {
          this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
        } else {
          this.$store.dispatch(this.request_prefix + "/changeOptions", completeparam)
        }
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    pOptions() {
      const rectAttr = this.getRectAttribute.call(this, this.ids).options
      const useActiveIndex = rectAttr.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.activeIndex
      return [rectAttr.rows[useActiveIndex]]
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input {
  width: 90px !important;
}
::v-deep .el-select {
  margin-bottom: 0px !important;
  margin-top: 0 !important;
  z-index: 100;
}
.bg_box {
  position: relative;
  margin: 0 auto;
  width: 95%;
  height: 201px;
  background-color: gray;
  border-radius: 4px;
}
::v-deep .el-input {
  width: 110px;
}
.element_point {
  position: absolute;
  color: white;
  font-size: 14px;
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  .element_point_item {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .text {
    margin-bottom: 0 !important;
    display: inline-block;
    line-height: 100%;
  }
}
</style>
